import React, { useContext } from 'react';
import { ControlledDateTimePickerDatatestid } from '../../../constants/index.js';
import { ControlledDateTimePickerContext } from '../../../ControlledDateTimePickerCTX.js';
import { HoursList } from './HoursList.js';
import { MeridiemList } from './MeridiemList.js';
import { MinutesList } from './MinutesList.js';
import {
  StyledTimePickerContainer,
  StyledTimePickerHead,
  StyledTimePickerWheelsLegend,
  StyledTimePickerWheelWrapper,
} from './Styleds.js';
import { TimeWheelFooter } from './TimeWheelFooter.js';

export const TimeWheelContent = React.memo(() => {
  const {
    isControllerOnly,
    hours,
    minutes,
    meridiem,
    getProps,
    props: { readOnly, applyAriaDisabled },
  } = useContext(ControlledDateTimePickerContext);

  return (
    <StyledTimePickerContainer
      isControllerOnly={isControllerOnly}
      data-testid={ControlledDateTimePickerDatatestid.CONTROLLER_COMPONENT.TIMEWHEEL}
      getOwnerProps={getProps}
      role="region"
      aria-label="timewheel"
    >
      <StyledTimePickerHead
        data-testid={ControlledDateTimePickerDatatestid.TIMEWHEEL.HEADER_LABEL}
        getOwnerProps={getProps}
      >{`${hours || '__'}:${minutes || '__'} ${meridiem || '__'}`}</StyledTimePickerHead>
      <StyledTimePickerWheelsLegend>
        <div>H</div>
        <div>M</div>
        <div>A</div>
      </StyledTimePickerWheelsLegend>
      <StyledTimePickerWheelWrapper $readOnlyStyles={readOnly || applyAriaDisabled}>
        <HoursList />
        <MinutesList />
        <MeridiemList />
      </StyledTimePickerWheelWrapper>
      <TimeWheelFooter />
    </StyledTimePickerContainer>
  );
});
